import { createAction, props } from '@ngrx/store';
export const setReportId = createAction('[Custom PDF Report Builder] Set Report ID', props());
